import React, { useEffect } from "react";
import "./ChangePassword.less";
import { Form, Input, Row, Col, Tooltip, Button, message } from "antd";
import { useMutation } from "@apollo/react-hooks";

import { CHANGE_PASSWORD } from "../../../Graphql/mutations";

export const ChangePassword = () => {
  const user_id = localStorage.getItem("user_id");
  const [form] = Form.useForm();

  const [CHANGE_PASSWORD_MUTATION, { loading: isChangingPassword }] =
    useMutation(CHANGE_PASSWORD);

  const submitChangePassword = async (value) => {
    value.user_id = user_id;
    delete value.conf_password;
    const { data } = await CHANGE_PASSWORD_MUTATION({
      variables: value,
    });
    if (data.change_password.status === "OK") {
      form.resetFields();
      message.success(data.change_password.message);
    } else {
      message.error(data.change_password.message);
    }
  };
  return (
    <div>
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5 className="">Change password </h5>
        </div>
      </div>
      <Form
        name="change-password"
        className="pt-md-5"
        form={form}
        onFinish={submitChangePassword}
      >
        <Row>
          <Col xs={24} sm={24} xl={10}>
            <Tooltip
              trigger={["focus"]}
              title="Current Password"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item
                name="old_password"
                rules={[
                  {
                    required: true,
                    message: "Please input your current password!",
                    whitespace: true,
                  },
                ]}
              >
                <Input.Password placeholder="Current Password" />
              </Form.Item>
            </Tooltip>
            <Tooltip
              trigger={["focus"]}
              title="Password"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item
                name="new_password"
                rules={[
                  {
                    whitespace: false,
                    required: true,
                    message: "Please input your new password!",
                  },
                  {
                    pattern: new RegExp(
                      "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+.,|_~`'\"]).{6,}$"
                    ),
                    message:
                      "Minimum 6 characters at least 1 Uppercase Alphabet, 1 Lowercase Alphabet, 1 Number and 1 Special Character!",
                  },
                ]}
              >
                <Input.Password placeholder="New Password" />
              </Form.Item>
            </Tooltip>
            <Tooltip
              trigger={["focus"]}
              title="Confirm Password"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item
                name="conf_password"
                rules={[
                  {
                    required: true,
                    message: "Please confirm password",
                  },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("The passwords are not matching");
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm Password" />
              </Form.Item>
            </Tooltip>
            <Form.Item className="text-center">
              <Button
                type="primary"
                shape="round"
                size="large"
                success
                htmlType="submit"
                loading={isChangingPassword}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
